/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app, Swiper) => {		
		// Tabs
		$(document).on('click', '.explore-apps-anchors .anchor', (e) => {
			let anchor = $(e.target).closest('button');
			let index = anchor.data('index');

			anchor.siblings('.active').removeClass('active');
			anchor.addClass('active');

			$('.explore-apps-content.active').removeClass('active');
			$(`.explore-apps-content[data-index="${index}"]`).addClass('active');
		});

		// Apps
		$('.explore-apps-content').each(function(){
			let wrapper = $(this);
			let icons = new Swiper(wrapper.find('.explore-apps-icons')[0], {
				slidesPerView: 'auto',
				wrapperClass: 'explore-apps-icons-wrapper',
				slideClass: 'explore-apps-icons-slide',
			});
			let descriptions = new Swiper(wrapper.find('.explore-apps-descriptions')[0], {
				slidesPerView: 'auto',
				autoHeight: true,
				wrapperClass: 'explore-apps-descriptions-wrapper',
				slideClass: 'explore-apps-descriptions-slide',
			});

			wrapper.on('click', '.explore-apps-icons-slide', (e) => {
				let icon = $(e.target).closest('div');
				let index = icon.data('index');

				descriptions.slideTo(index);
			});

			descriptions.on('activeIndexChange', function(e){
				wrapper.find('.explore-apps-icons-slide.active').removeClass('active');
				wrapper.find(`.explore-apps-icons-slide[data-index="${descriptions.activeIndex}"]`).addClass('active');

				icons.slideTo(descriptions.activeIndex);
			});
		});

		$(document).on('click', '[data-ajax-task]', (e) => {
			e.preventDefault();
			
			let link = $(e.target).closest('a');
			let route = link.data('ajax-task');

			$.ajax({
				url: route,
				method: 'GET',
				dataType: 'json',
				success: (response) => {
					// console.log(response);
				},
				error: (response) => {
					// console.log(response);
				}
			});
		});
	}
}

